<template>
	<div class="middleBox"> 
		<div class="stepForm"> 
			<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
			<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
			<!-- <div class="row" v-if="test_step == 0">
				<div class="col-12 mobPad">
					<h4 class="title mob-center pb-3 border-bottom text-left mb-4">{{$t('stepMsz4')}}</h4>
				</div>
				<div class="col-12 mobPad text-center">
					<div class="icon mb-5">
                        <img src="../../../../static/fxView/images/test.svg" alt="Email Support" width="220">
                    </div>
					<p class="mb-3">{{$t('stepMsz5')}}</p>
					<div class="row">
						<div class="col-12">
		                    <div class="full-width border-top pt-3  mt-3 w-100">
		                        <button class="prism_btn btn_sm" @click="startTestEvent">{{$t('startTest')}} </button>
		                    </div>
		                </div>
					</div>
				</div> 
			</div> -->
			<!-- ====={{ tmaResult }}  {{ test_step }} {{ showTmaContinue }}  ------------{{  test_step == 2 || showTmaContinue }} -->
			<!-- <div class="row" v-if="!tmaEnabled && tmaResult">
				<div class="col-12 mobPad">
					<h4 class="title mob-center pb-3 border-bottom text-left mb-4" v-if="get_user.profile.tma_enabled && get_user.profile.tma_result && tmaResult">{{ tmaResult[0].tma_result.assessment_type }}</h4>
				</div>
				<div class="col-12 mobPad text-center" v-if="tmaResult[0].tma_enabled &&  tmaResult[0].tma_result">
					<div class="icon mb-5">
                        <img src="../../../../static/fxView/images/test.svg" alt="Email Support" width="220">
                    </div>
					<p class="mb-3" v-html="tmaResult[0].tma_result.assessment_remarks"></p>
				</div> 
			</div> -->
			
			<!-- -------------- {{ test_step }}   +++ {{ showTmaContinue }} -->
			<div v-if="test_step == 1 && !showTmaContinue">
				<!-- <div class="col-12 mobPad question_answer" v-if="answerList.length > 0"> -->
				<div class="col-12 mobPad question_answer" v-if="(Object.values(this.answer_list) || []).length > 0">
					<div class="col-12 mobPad" ref="question_form">
						<div v-for="(questions, type) in groupedQuestions" :key="type" class="mb-3">
							<div class="d-flex align-items-center justify-content-between pb-3 border-bottom text-left mb-3">
								<h4 class="title">{{type}}</h4>
								<!-- <p class="qusNo mb-0">{{show_question + 1}} {{$t('Of')}} {{Object.keys(answer_list).length}}</p> -->
							</div>
						<div v-for="(ques,index) in questions"  :key="ques.question_id">
							<h5 class="subtitle" :ref="ques.question_id+'questionInput'">{{ques.question}}</h5>
							<ul class="twoColumn">
								<li v-for="ans_list in ques.answers" :class="answer_Selected[ques.question_id] == ans_list.ans_id?'selected':''">
									<label class="customRadio-button">{{ans_list.answer}}
										<!-- comment the focus code for TMA -->
										<!-- <input type="radio" class="form-control" :id="ques.question_id" :name="ques.question_id+'question'" :value="ans_list.ans_id" v-model="answer_Selected[ques.question_id]" v-validate="answer_Selected[ques.question_id]?'':'required'" :disabled="disable" @focus="trackFzEvent(ques.sequence)"> -->
										<input type="radio" class="form-control" :id="ques.question_id" :name="ques.question_id+'question'" :value="ans_list.ans_id" v-model="answer_Selected[ques.question_id]" v-validate="answer_Selected[ques.question_id]?'':'required'">
										<span class="checkmark"></span>
									</label>
								</li>
							</ul>
							<p class="error mb-3" v-if="submitted && errors.has(ques.question_id+'question')">{{$t('fieldReq')}}</p>
						</div>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
		                    <div class="full-width border-top pt-3 submitButton align-items-center d-flex spacebetween mt-3 w-100">
								<div class="leftbtn">
									<a href="#"  v-on:click="doitLaterEvent" >{{$t('iDoLater')}}</a>
								</div> 
		                        <!-- <div class="leftbtn">
		                        	<button class="prism_btn btn_sm grayBtn" v-on:click="prevButtonEvent" v-if="testType == 'knowledge' && is_trading_experience == 2">{{$t('preQues')}}</button>
		                        	<button class="prism_btn btn_sm grayBtn" v-on:click="prevBtnEvent" v-else>{{$t('preQues')}}</button>
		                        </div> -->
								<!-- <button class="prism_btn btn_sm" v-on:click="next('next')" v-if="testType == 'trade' && is_trading_experience == 2">{{$t('nextQues')}}</button>  -->
								<button class="prism_btn btn_sm" v-on:click="next('save')">{{$t('saveContinue')}} </button>
		                    </div>
		                </div>
					</div>
				</div>
			</div>
			
			<div class="row" v-else-if="tmaEnabled && !!tmaResult">
				<div v-if="!!tmaResult">
					<div class="col-12 mobPad">
						<h4 class="title mob-center pb-3 border-bottom text-left mb-4">{{tmaResult.assessment_type}}</h4>
					</div>
					<div class="col-12 mobPad text-center">
						<div class="icon mb-5">
							<img src="../../../../static/fxView/images/test.svg" alt="Email Support" width="220">
						</div>
						<p class="mb-3" v-html="tmaResult.assessment_remarks"></p>
						<div class="row">
							<div class="col-12">
								<div class="full-width border-top pt-3  mt-3 w-100">
									<button class="prism_btn btn_sm" @click="goToNextTest" v-if="tmaResult.assessment_result === 'ACCEPTED' || tmaResult.assessment_result === 'GREY_AREA' || tmaResult.assessment_result === 'GREY_AREA_4'">{{$t('Continue')}} </button>
								</div>
							</div>
						</div>
					</div> 
				</div> 
			</div>
		</div>
	</div>
</template>
<script>
	import * as types from '@/types'
    import { mapActions } from 'vuex'
    import { fxViewMixins } from '@/plugins/fxView'
	
    export default {
        name: 'stepThreeA',
        mixins: [fxViewMixins],
        data() {
            return {
            	response_msg : '',
                msg_type : '',
                pageLoader : false,
				step : 3,
				submitted: false,
				disable: false,
				test_step : 0,
				answer_list : {},
				answer_Selected:[],
				tmaResult: null,
				tmaEnabled: false,
				showTmaContinue: ''
            }
        },
		computed:{
			answerList(){
				return Object.values(this.answer_list) || []
			},
			groupedQuestions() {
			return this.answerList.reduce((groups, question) => {
				const type = question.type;
				if (!groups[type]) {
				groups[type] = [];
				}
				groups[type].push(question);
				return groups;
			}, {});
			}
		},
		methods:{
			...mapActions({
                _runRegisterStepThreeTma: types.RUN_REGISTER_STEP_TMA,
				_runGetQuestionAnswerTma: types.RUN_GET_QUESTION_ANSWER_TMA,
				_runTmaUserResponse: types.RUN_TMA_USER_RESPONSE
            }),
            next(event){
            	const _that = this;
				_that.submitted = true;
				_that.$validator.validate().then(valid => {
					if(valid){
						_that.submitted = false;
            			
						_that.submit()
					}else{
						_that.handleValidationErrorAdvanced(_that.errors)
					}
				});
            },
			doitLaterEvent(){
				this.$trackEvent('CP+Client+Verification+5+Later');
				this.$parent.do_later = true
			},
			submit(){
				if(this.disable){
                    let currentStep = this.get_user.step

                    if('tempStep' in this.get_user && currentStep < this.get_user.tempStep){
                        currentStep = this.get_user.tempStep
                    }
                    this.get_user.tempStep = currentStep
                    this.get_user.step = 3         
                    let user_json = this.get_user
                    this.$store.commit(types.SET_STATE, user_json)
                }else{
					const _that = this
					_that.submitted = true;
					_that.$validator.validate().then(valid => {
						let newArr = []
						for(const key in _that.answer_list){
							if(_that.answer_list[key].answers && _that.answer_Selected[_that.answer_list[key].question_id]){
								const arr = Object.entries(_that.answer_list[key].answers).map(e => ({ans_id: e[1].ans_id, question_id: e[1].question_id}));
								const data = arr.find((v)=>v.ans_id == _that.answer_Selected[_that.answer_list[key].question_id])
								newArr.push(data)
							}
						}
						if (valid) {
							let input_json={
								'globalParams' :{
									'ques_ans_array': newArr,
								},
								'localParams' :{
									"parameter" : _that
								}
							}
							_that._runRegisterStepThreeTma(input_json)
						}else{
							_that.handleValidationErrorAdvanced(_that.errors)
						}
					}).catch (ex => {
						console.log('ex', ex)
					});
				}
			},
			getStep(){
				this._runGetUserRegisterationStepData({'globalParams' :{},'localParams' :{ "parameter" : this , "step" : '3'}})
			},
			// startTestEvent(){
			// 	this.test_step = 1
			// 	// this.$trackEvent('CP+Client+Verification+4+Start')
			// 	// this.$trackEvent('CP+Client+Verification+5+Pageview')
			// },
			goToNextTest() {
				// let user_json = this.$store.getters['GET_USER']
				this.showTmaContinue = false
				let user_json = this.get_user
				var user = localStorage.getItem('user')
				user = atob(user);
				user = JSON.parse(user)
				user_json.step = 3;
				user.step = 3;
				this.$store.commit(types.SET_STATE, user_json)
				localStorage.setItem('user', btoa(JSON.stringify(user)))
			},
		},
		//  async mounted(){
		// 	 const _that = this
		// 	//  await _that._runTmaUserResponse({'globalParams' :{},'localParams' :{"parameter" : _that}});
		// 	//  if(!this.tmaResult){
		// 	// 	this.test_step = 1
		// 	// 	this.showTmaContinue = false
		// 	// 	await _that._runGetQuestionAnswerTma({'globalParams' :{},'localParams' :{"parameter" : _that}})
		// 	// 	 console.log('we are in mounted tmres', this.tmaResult, this.test_step, this.showTmaContinue, this.answerList)
		// 	// }
		// 	//this.tmaResult=tmaResult[0]["tma_result"]
		// 	// this.tmaResult = JSON.parse(this.get_user.profile.tma_result);
		// },
		async created(){

			const _that = this
			if (this.tmaResult == null && this.get_user.profile.tma_enabled === "Y") {
				// this.tmaEnabled = false;
				// _that._runGetQuestionAnswerTma({'globalParams' :{},'localParams' :{"parameter" : _that}})
			} 
			else if (this.tmaResult && this.tmaResult[0] && this.get_user.profile.tma_enabled === "N") {
				this.tmaEnabled = false;
				// this.tmaResult = this.get_user.profile.tmaFullResult;
				// this.showTmaContinue = true;
			} 
			else  {
				

				// console.log('3')
				// this.tmaEnabled = true;
				
				//this.showTmaContinue = false;
				//_that._runGetQuestionAnswerTma({'globalParams' :{},'localParams' :{"parameter" : _that}})
				
			}
			// console.log('render the created', _that.tmaResult);
				await _that._runTmaUserResponse({'globalParams' :{},'localParams' :{"parameter" : _that}});

			 if(!this.tmaResult){
				this.test_step = 1
				await _that._runGetQuestionAnswerTma({'globalParams' :{},'localParams' :{"parameter" : _that}})
				//  console.log('we are in mounted tmres', this.tmaResult, this.test_step, this.showTmaContinue, this.answer_list)
			}
		},
		// destroyed() {
		// 	if (this.get_user.profile.tma_result === 'ACCEPTED') {
		// 		this.goToNextTest();
		// 	}
		// },
    }
</script>



// WEBPACK FOOTER //
// src/components/fxView/registerSteps/step3.0.vue